import styled from 'styled-components';
import Box from '../Box';
import withTransition, { propTypes } from './withTransition';
var SlideDownStyled = styled(Box).withConfig({
  displayName: "SlideDown__SlideDownStyled",
  componentId: "sc-1a8ztoe-0"
})(["transform:", ";transition:", ";"], function (props) {
  if (props.state === 'exited' || props.state === 'exiting') {
    return 'translate3d(0,-100%,0)';
  }

  if (props.state === 'entered' || props.state === 'entering') {
    return 'translate3d(0,0,0)';
  }
}, function (props) {
  return "transform ".concat(props.duration, "ms ").concat(props.easing, " 0ms");
});
export var SlideDown = withTransition(SlideDownStyled);
SlideDown.propTypes = propTypes;
SlideDown.defaultProps = {
  duration: 300
};